module.exports = __webpack_public_path__ + "img/tile-06.81a17fbe.png";